import React from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { InputLabel } from '@this/shared/ui/inputs/form_control';
import { styled } from '@this/constants/themes';
import SimpleLoading from '@this/shared/simple_loading/simple_loading';
import type FreeeAccountItem from '@this/domain/organization/freee_account_item';
import type ExpensesAccountType from '@this/domain/expenses/expenses_account_type';
import FilterableSelector from '@this/shared/filterable_selector/filterable_selector';
import { Button } from '../../shared/ui/inputs/button';

type Props = {
  type: ExpensesAccountType;
  submitting: boolean;
  isFreeeConnected: boolean;
  freeeAccountItems: FreeeAccountItem[];
  onSubmit: () => void;
  onClickCancel: () => void;
  errors: string[];
};

const Form: React.FC<Props> = ({
  type,
  submitting,
  isFreeeConnected,
  freeeAccountItems,
  onSubmit,
  onClickCancel,
  errors
}) => {
  const freeeAccountItemOption = (): any[] => {
    return freeeAccountItems.map(f => {
      return {
        label: f.name,
        value: f.id.toString(),
        matcher: f.name
      };
    });
  };

  const findFreeeAccountItemOptionByValue = (value: string) => {
    const target = _.find(freeeAccountItems, item => {
      return item.id.toString() === value;
    });

    if (target) {
      return {
        label: target.name,
        value: target.id.toString(),
        matcher: target.name
      };
    }
    return {
      label: '',
      value: '',
      matcher: ''
    };
  };

  return (
    <>
      <form onSubmit={() => onSubmit()}>
        <div className="type-edit">
          <div className="type-edit__section">
            <InputLabel htmlFor="name" className="type-edit__label">
              勘定科目名
            </InputLabel>
            <input
              id="name"
              type="text"
              value={type.name || ''}
              onChange={e => {
                type.name = e.target.value;
              }}
            />
          </div>
          <div className="type-edit__section">
            <div className="type-edit__input_area">
              <InputLabel htmlFor="code" className="type-edit__label">
                勘定科目コード
              </InputLabel>
              <input
                id="code"
                type="text"
                value={type.code || ''}
                onChange={e => {
                  type.code = e.target.value;
                }}
              />
            </div>
          </div>
          {isFreeeConnected && (
            <div className="type-edit__section">
              <div className="type-edit__input_area">
                <InputLabel htmlFor="filterable-selector-input" className="type-edit__label">
                  freee勘定科目名
                </InputLabel>
                <FilterableSelector
                  placeholder="勘定科目を検索"
                  options={freeeAccountItemOption()}
                  selected={findFreeeAccountItemOptionByValue(type.freeeAccountItemId || '')}
                  onSelect={option => {
                    type.freeeAccountItemId = option?.value;
                  }}
                />
              </div>
            </div>
          )}
          <div className="type-edit__section">
            <div className="type-edit__input_area">
              <InputLabel htmlFor="departments" className="type-edit__label">
                部署コード
              </InputLabel>
              <TheTextarea
                id="departments"
                placeholder="部署コード1&#13;部署コード2"
                value={type.departments || ''}
                onChange={e => {
                  type.departments = e.target.value;
                }}
              />
              <p>
                出張申請時にこの勘定科目を選択できるようにしたい費用負担部署の部署コードを改行区切りで入力ください。
                <br />
                指定しない場合、すべてのユーザがこの勘定科目を選択できます。
                <br />
                <br />
                出張申請時にユーザが勘定科目を選択できるようにするためには、別途「原価計算オプション」をお申し込みいただく必要があります。
              </p>
            </div>
          </div>
        </div>
        <div style={{ marginTop: '20px' }}>
          <Button style={{ marginRight: '10px' }} disabled={submitting} onClick={() => onClickCancel()}>
            キャンセル
          </Button>
          <Button disabled={submitting} onClick={() => onSubmit()}>
            保存
          </Button>
        </div>
        {errors && errors.map((e, i) => <p key={i}>{e}</p>)}
      </form>
      {submitting && <SimpleLoading />}
    </>
  );
};

const TheTextarea = styled.textarea`
  max-width: 500px;
  height: 100px;
`;

export default observer(Form);
